<template>
  <table class="table mb-0 sign-up-logs table-striped">
    <thead>
      <tr>
        <th class="text-center">Level</th>
        <th class="text-center">Logged At</th>
        <th class="text-center">Reference</th>
        <th>Details</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="signUp of signUps"
        :key="signUp.Id"
        :class="signUp._tableClass"
      >
        <td class="fwfont font-weight-bold text-center position-relative no-pad">{{ signUp.Level }}</td>
        <td class="text-center" style="white-space: nowrap;">{{ signUp.LoggedAt | shortDateTime }}</td>
        <td class="text-center">{{ signUp.RecordIdentifier }}</td>
        <td>
          <div v-if="signUp.Message" class="text-left">
            <p class="font-weight-bold d-inline">Message:</p>
            <p style="overflow-wrap: anywhere; white-space: pre-line">
              {{ signUp.Message }}
            </p>
          </div>
          <div v-if="signUp.Guidance" class="text-left">
            <p class="font-weight-bold d-inline">Guidance:</p>
            <p style="overflow-wrap: anywhere; white-space: pre-line">
              {{ signUp.Guidance }}
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import _filters from "@/mixins/filters.js";

export default {
  name: "TableSignUps",
  
  mixins: [_filters],

  props: {
    signUps: {
      type: Array,
      required: true,
    },
  },
};
</script>